import PropTypes from 'prop-types'
import React from 'react'
import { observer, inject } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import DatePicker from 'react-datepicker'
import ListStore from 'react-mobx-admin/state/data_table'
import moment from 'moment'
import {
  Button,
  ButtonGroup,
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap'

const DateFilter = ({ store }) => {
  const disabled = store.cv && store.cv.state && store.cv.state === 'loading'

  const DateFilterButton = ({ onClick }) => {
    return (
      <ButtonGroup className='btn-group-top-right'>
        {store.dateFilterValue &&
          <OverlayTrigger placement='top' overlay={<Tooltip>{store.__('Remove date filter')}</Tooltip>}>
            <Button bsStyle='default' disabled={disabled} onClick={() => store.dateFilterUpdate()}>{' X '}</Button>
          </OverlayTrigger>
        }
        <OverlayTrigger placement='top' overlay={<Tooltip>{store.__('Click to set the global date filter')}</Tooltip>}>
          <Button bsStyle={store.dateFilterValue ? 'success' : 'default'} disabled={disabled} onClick={onClick}>
            <i className='glyphicon glyphicon-calendar' />&nbsp;
            {store.dateFilterValue || store.__('Date')}
          </Button>
        </OverlayTrigger>
      </ButtonGroup>
    )
  }
  DateFilterButton.propTypes = {
    onClick: PropTypes.func
  }

  let selectedValue = ''
  const dateFilterMoment = store.dateFilterValue && moment(store.dateFilterValue)
  if (dateFilterMoment && dateFilterMoment.isValid()) {
    selectedValue = new Date(
      Date.UTC(dateFilterMoment.year(), dateFilterMoment.month(), dateFilterMoment.date(), 0, 0, 0)
    )
  }

  return (
    <ButtonGroup className='btn-group-top-right'>
      <DatePicker
        className='btn-group-top-right'
        customInput={<DateFilterButton />}
        dateFormat={defaultConst.DATE_FORMAT.replace('DD', 'dd')}
        locale={defaultConst.DATE_LANGUAGE}
        onChange={(val) => store.dateFilterUpdate(val)}
        popperPlacement={'right-start'}
        selected={selectedValue}
        showMonthDropdown
        showWeekNumbers
        showYearDropdown
        todayButton={store.__('Insert current day')}
      />
    </ButtonGroup>
  )
}
DateFilter.propTypes = {
  store: PropTypes.instanceOf(ListStore).isRequired
}

export default inject('store')(observer(DateFilter))
